export default __webpack_public_path__ + "static/media/icon_hamburger_menu_focus.c236667b.svg";